((app, ng) => {

    app.config($stateProvider => {
        $stateProvider.state("Home.Appointment",
            {
                url: "/Appointment/{appointmentId}",
                component: "appointment",
                resolve: {
                    appointment: (appointmentApi, $transition$) => {
                        return appointmentApi.getAppointment($transition$.params().appointmentId);
                    },
                    notes: (appointmentApi, $transition$) => {
                        return appointmentApi.getAppointmentNotes($transition$.params().appointmentId);
                    }
                }
            });
    });

    app.component("appointment",
        {
            templateUrl: "/App/Appointment/appointment.html",
            controller: appointmentController,
            bindings: {
                appointment: "<",
                currentUser: "<",
                notes: "<"
            }
        });

    function appointmentController($q, $window, $state, moment, _preferredCommunications, appointmentApi, appointmentDetailApi, clientApi, userApi, modalService, FieldStatusesModel, $filter) {
        const $ctrl = this;

        this.$onInit = () => {
            $ctrl.notes.sort((a, b) => moment(b.CreatedOn) - moment(a.CreatedOn));
            updateExportCalendarDescription();
            $ctrl.assignedUsers = [];
            $ctrl.attendees = [];
            $ctrl.appointmentDetails = [];
            $ctrl.scheduledTasks = [];
            $ctrl.selectedStartDate = $ctrl.appointment.StartDate;
            $ctrl.selectedStartTime = $ctrl.appointment.StartDate;
            $ctrl.selectedEndDate = $ctrl.appointment.EndDate;
            $ctrl.selectedEndTime = $ctrl.appointment.EndDate;
            $ctrl.preferredCommunications = _preferredCommunications;
            $ctrl.modalService = modalService;
            $ctrl.appointmentTasks = [];
            $ctrl.ui = {
                loading: true
            };
            $ctrl.savingStatusForAppointment = new FieldStatusesModel({
                Name: "",
                MainAttendee: "",
                StartDate: "",
                EndDate: "",
                Location: "",
                Color: ""
            });

            const promises = [
                appointmentApi.getAppointmentAssignedUsers($ctrl.appointment.Id),
                appointmentApi.getAppointmentAttendees($ctrl.appointment.Id),
                appointmentDetailApi.getAppointmentDetails($ctrl.appointment.Id),
                appointmentApi.getScheduledTasks($ctrl.appointment.Id)
            ];

            $q.all(promises).then(responses => {
                [$ctrl.assignedUsers, $ctrl.attendees, $ctrl.appointmentDetails, $ctrl.scheduledTasks] = responses;

                $ctrl.attendees = $ctrl.attendees.filter(attendee => attendee.Id !== $ctrl.appointment.MainAttendee.Id);

                $ctrl.ui.loading = false;
            });
        };

        const updateExportCalendarDescription = () => {
            $ctrl.ExportCalendarDescription = `Appointment with ${$ctrl.appointment.MainAttendee.Person.FirstName} ${$ctrl.appointment.MainAttendee.Person.LastName} from ForceCRM` + "\n" + $ctrl.notes.map(n => `${$filter('date')(n.CreatedOn, 'MMM d, yyyy - h:mm a')} : ${n.CreatedBy.FirstName} ${n.CreatedBy.LastName} ${n.Content}`).join("\n");
        };

        const updateAppointment = (appointment, editedField) => {
            if (appointment.MainAttendee) {
                $ctrl.savingStatusForAppointment.findFieldStatusByName(editedField).startSaving();
                appointmentApi.updateAppointment(appointment.Id, appointment)
                    .then(function () {
                        $ctrl.savingStatusForAppointment.findFieldStatusByName(editedField).succeed();
                    }).catch(function () {
                        $ctrl.savingStatusForAppointment.findFieldStatusByName(editedField).fail();
                    });
            }
        };

        const updateColor = (parmeterAppointment, parameterColor) => {
            parmeterAppointment.Color = parameterColor;
            $ctrl.updateAppointment(parmeterAppointment, "Color");
        };

        const updateAppointmentStartDateTime = (appointment, propertyName, startDate, startTime) => {
            if (startDate instanceof Date) {
                $ctrl.appointment.StartDate = new Date(startDate.getFullYear(),
                    startDate.getMonth(),
                    startDate.getDate(),
                    startTime.getHours(),
                    startTime.getMinutes());
            } else {
                $ctrl.appointment.StartDate = new Date(`${startDate} ${startTime.getHours()}:${startTime.getMinutes()}`);
            }

            $ctrl.updateAppointment(appointment, propertyName);
        };

        const updateAppointmentEndDateTime = (appointment, propertyName, endDate, endTime) => {

            if (endDate instanceof Date) {
                $ctrl.appointment.EndDate = new Date(endDate.getFullYear(),
                    endDate.getMonth(),
                    endDate.getDate(),
                    endTime.getHours(),
                    endTime.getMinutes());
            } else {
                $ctrl.appointment.EndDate = new Date(`${endDate} ${endTime.getHours()}:${endTime.getMinutes()}`);
            }

            $ctrl.updateAppointment(appointment, propertyName);
        };

        const updateAppointmentDetails = (appointment) => {
            appointmentApi.updateAppointmentDetails(appointment.Id, appointment);
        };

        const completeAppointment = (appointment) => {
            appointment.IsCompleted = true;

            appointmentApi.completeAppointment(appointment.Id);
        };

        const deleteAppointment = (appointmentId, $event) => {
            modalService.confirmAppointmentDeletion($event).then(() => {
                $ctrl.ui.loading = true;

                appointmentApi.deleteAppointment(appointmentId).then(() => {
                    $ctrl.goToPreviousPage();
                });
            });
        };

        const addAttendee = (appointmentId, attendee) => {
            if (!!attendee) {
                $ctrl.attendees.push(attendee);

                appointmentApi.addAttendee(appointmentId, attendee.Id);
            }
        };

        const removeAttendee = (appointmentId, attendeeId) => {
            appointmentApi.removeAttendee(appointmentId, attendeeId);
        };

        const addAssignedUser = (appointmentId, assignedUser) => {
            if (!!assignedUser) {
                $ctrl.assignedUsers.push(assignedUser);

                appointmentApi.addAssignedUser(appointmentId, assignedUser.Id);
            }
        };

        const removeAssignedUser = (appointmentId, assignedUserId) => {
            appointmentApi.removeAssignedUser(appointmentId, assignedUserId);
        };

        const addNote = (appointmentId, content) => {
            if (content.length > 0) {
                const note = {
                    Content: content,
                    CreatedBy: $ctrl.currentUser,
                    CreatedOn: new Date()
                };

                $ctrl.notes.unshift(note);
                updateExportCalendarDescription();
                appointmentApi.addAppointmentNote(appointmentId, note).then(response => {
                    note.NoteId = response;
                });
            }
        };

        const removeNote = (appointmentId, noteId) => {
            const noteIndex = $ctrl.notes.findIndex(note => note.NoteId === noteId);

            $ctrl.notes.splice(noteIndex, 1);
            updateExportCalendarDescription();
            appointmentApi.removeAppointmentNote(appointmentId, noteId);
        };

        const searchClients = (term) => {
            return clientApi.searchClients(term).then(clients => {
                return clients.filter(client => {
                    const isMainAttendee = !!$ctrl.appointment.MainAttendee &&
                        $ctrl.appointment.MainAttendee.Id === client.Id;

                    const isAdditionalAttendee = $ctrl.attendees.some(attendee => attendee.Id === client.Id);

                    return !isMainAttendee && !isAdditionalAttendee;
                });
            });
        };

        const searchUsers = (term) => {
            return userApi.searchUsers(term).then(users => {
                return users.filter(user => !$ctrl.assignedUsers.some(assignedUser => assignedUser.Id === user.Id));
            });
        };

        const goToClient = (clientId) => {
            return $state.go("Home.Client", { "clientId": clientId });
        };

        const goToPreviousPage = () => {
            $window.history.back();
        };

        const buildPreferredCommunicationStr = (client, preferredCommunication) => {
            let prefCommStr = $ctrl.preferredCommunications.find(communication => {
                return communication.ShortName === preferredCommunication;
            });

            const startsWithEmail = preferredCommunication.startsWith("Email");

            if (startsWithEmail && client.Person.PrimaryEmailAddress) {
                prefCommStr = `${prefCommStr}: ${client.Person.PrimaryEmailAddress.Value}`;
            }
            else if (!startsWithEmail && client.Person.PrimaryPhoneNumber) {
                const phoneNumber = client.Person.PrimaryPhoneNumber.Value.replace(/(\d{3})(\d{3})(\d+)/, "$1-$2-$3");

                prefCommStr = `${prefCommStr}: ${phoneNumber}`;
            }

            return prefCommStr;
        };

        const formatAttendeeDisplay = (client) => {
            let result = `${client.Person.FirstName} ${client.Person.LastName}`;

            if (!!client.Person.PreferredCommunication) {
                const preferredCommunication = buildPreferredCommunicationStr(client.Person);

                result = `${result} (${preferredCommunication})`;
            }

            return result;
        };

        ng.extend($ctrl,
            {
                updateAppointment,
                updateAppointmentDetails,
                completeAppointment,
                deleteAppointment,
                addAttendee,
                removeAttendee,
                addAssignedUser,
                removeAssignedUser,
                addNote,
                removeNote,
                searchClients,
                searchUsers,
                goToClient,
                goToPreviousPage,
                formatAttendeeDisplay,
                updateColor,
                updateAppointmentStartDateTime,
                updateAppointmentEndDateTime
            });
    }

})(window.app, window.angular);